module.exports = __webpack_public_path__ + "img/telBg.3eb70790.png";